<template>
    <div class="position-absolute">
        <div id="TwistHole"/>
    </div>
</template>

<script setup>
import p5 from 'p5'
import {ref, reactive, onMounted, watch, watchEffect, onUnmounted} from 'vue'
import defaultValue from "@/utils/defaultValue"
import colorTool from "@/utils/colorTool";

const {defaultWidth, defaultHeight} = defaultValue()
const props = defineProps(['currentValue', 'effectTheme'])
const { changeToRgb } = colorTool()


const effectThemeData = reactive(props.effectTheme)
let canvasWrap = ref('stop')

let animateSpeed = ref(1) //1-10
let high = ref(null)
let low = ref(null)
let backgroundColor = ref('rgb(0,0,0)')
let nowTemperature = ref(null)
let drawPot = ref(0)


const handleGetAnimateSpeed = (high, low, now = 5) => {
  let lowHeightRange = Math.ceil((high - low) / 10) // 將高低差 分為 10個單位, 1單位

  // 設定速度
  let range = Math.trunc((now - low) / lowHeightRange)
  if (range <= 0) animateSpeed.value =  20
  else if (range >= 10 ) animateSpeed.value = 80
  else animateSpeed.value = 20 + (6 * range)
}


const twistHoleAnimate = (sketch) => {
  let cw = defaultWidth.value
  let ch = defaultHeight.value
  let xmotion = 0;
  let ymotion = 0;
  let zmotion = 0;
  let radius = 120;
    sketch.setup = () => {
        sketch.createCanvas(cw, ch);
        sketch.colorMode(sketch.HSB, 360, 100, 100, 255);
        sketch.noStroke();
        sketch.strokeWeight(1);
        sketch.noiseDetail(7, 0.5)
        sketch.background(backgroundColor.value)
    }

    sketch.draw = () => {
      drawPot.value++
      sketch.noStroke();
      sketch.fill(0, 0, 0, 32);
      sketch.rect(0, 0, cw, ch);
      sketch.noFill();
      let count = 10;
      let x = cw / 2
      let y = ch / 2
      for (let j = 0; j < 1; j += 0.002) {
        let jnorm_j = sketch.abs(0.5 - j) * 2;
        for (let i = 0; i < count; i += 1) {
          let norm_i = i / count;
          let unit_i = 1 / count;
          let inorm_i = sketch.abs(0.5 - norm_i) * 2;
          let n = sketch.noise(inorm_i + xmotion, jnorm_j + ymotion) / 128;
          let rad1 = radius + sketch.cos(xmotion * sketch.PI * 2 + inorm_i * sketch.PI * radius + jnorm_j * sketch.PI * 4) / (0.4 + sketch.abs(sketch.sin(xmotion) * 2));
          let rad2 = radius + sketch.sin(ymotion * sketch.PI * 2 + inorm_i * sketch.PI * radius + jnorm_j * sketch.PI * 4) / (0.4 + sketch.abs(sketch.cos(zmotion) * 2));
          let cx = rad1 * sketch.sin(norm_i * sketch.PI * 2 + n * 4 + xmotion + (j * sketch.PI * 2)) + sketch.sin(xmotion * 2);
          let cy = rad1 * sketch.cos(norm_i * sketch.PI * 2 + n * 4 + ymotion + (j * sketch.PI * 2)) + sketch.cos(ymotion * 2);
          let cx2 = rad2 * sketch.sin((unit_i + norm_i) * sketch.PI * 2 + xmotion + (j * sketch.PI * 2)) + sketch.sin(xmotion * 2);
          let cy2 = rad2 * sketch.cos((unit_i + norm_i) * sketch.PI * 2 + ymotion + (j * sketch.PI * 2)) + sketch.cos(ymotion * 2);
          sketch.stroke(192 + inorm_i * 128 + jnorm_j * 128, 128 * (1 - j), 256, 256 * (n * 32));
          sketch.line(x + cx / j, y + cy / j, x + cx2 / j, y + cy2 / j);
          sketch.noStroke()
        }
      }
      // 控制速度
      xmotion += (0.004 * animateSpeed.value);
      ymotion += (0.004 * animateSpeed.value);
    }
    sketch.windowResized = function () {
        // sketch.resizeCanvas(sketch.windowWidth, sketch.windowHeight, true);
        cw = document.documentElement.clientWidth
        ch = document.documentElement.clientHeight
        sketch.resizeCanvas(cw, ch, true);
        radius = cw * 120 / 480
    }
}

function initAnimate () {
  if (canvasWrap.value !== 'stop') {
    canvasWrap.value.remove()
    canvasWrap.value = 'stop'
  }
}

watch(drawPot, (n, o) => {
  if (n > 7200) { // 2min init
    initAnimate()
    canvasWrap.value = new p5(twistHoleAnimate, 'TwistHole')
    drawPot.value = 0
  }
})

watch(() => effectThemeData.Sensor, (Sensor) => {
  if (Sensor) {
    initAnimate()
    canvasWrap.value = new p5(twistHoleAnimate, 'TwistHole')
  }
})

watchEffect(() => {
  const {
    Effect,
    HighValue,
    LowValue,
    IsDynamicMode,
    Speed: rotateSpeed,
    BackgroundColor
  } = effectThemeData


  nowTemperature.value = props.currentValue && props.currentValue !== null ? props.currentValue : ''
  backgroundColor.value = typeof BackgroundColor === "object" && BackgroundColor.length > 0 ? changeToRgb(BackgroundColor) : 'rgb(0,0,0)'

  if (IsDynamicMode.toString() === 'false') {
    if (rotateSpeed && rotateSpeed > 0) animateSpeed.value = rotateSpeed
  } else if (IsDynamicMode.toString() === 'true') {
    high.value = HighValue
    low.value = LowValue
    handleGetAnimateSpeed(high.value, low.value, nowTemperature.value)
  }

})

onMounted(() => {
  // create p5
  if (canvasWrap.value === 'stop') canvasWrap.value = new p5(twistHoleAnimate, 'TwistHole')
})

onUnmounted(() => {
  animateSpeed.value = 1
  high.value = null
  low.value = null
  backgroundColor.value = 'rgb(0,0,0)'
  nowTemperature.value = null
  drawPot.value = 0
  initAnimate()
})
</script>
